import { getFrontImage } from "@grandvisionhq/utils";
const getSubscriptionImageUrl = (variantInfo) => {
  const imageUrl = getFrontImage(variantInfo.images).url;
  return `${imageUrl}?w=300&bg=FFFFFF&fm=jpeg&auto=format`;
};
export {
  getSubscriptionImageUrl
};
//# sourceMappingURL=get-subscription-image-url.js.map
